import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import { BASE_NAME } from "../../routes";
import * as Papa from 'papaparse';
import { Spinner } from "@material-tailwind/react";
import CardTable from "../Table/CustomTable";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

const Courses = () => {

    const translationPrefix = 'Teaching'
    const { t } = useTranslation('global');
    const [cursos, setCursos] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const columns = [
        {
            id: 'nombre',
            label: t(`${translationPrefix}.nombre`),
        },
        {
            id: 'tipo',
            label: t(`${translationPrefix}.type`),
        },
        {
            id: 'semestre',
            label: t(`${translationPrefix}.course_schedule`),
        },
        {
            id: 'link_curso_fing',
            label: t(`${translationPrefix}.course_info`),
        },
        {
            id: 'link_eva',
            label: t(`${translationPrefix}.course_link`),
        }
        
    ]

    useEffect(() => {
        fetch(`${BASE_NAME}/data/cursos.csv`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.text();
        })
        .then(data => {
            const parsedData = Papa.parse(data, { header: true,  delimiter: ',' }).data;
            setRowCount(parsedData.length);
            setCursos(parsedData);
            setLoading(false);
        })
        .catch(error => console.error('Error fetching CSV data:', error));
    }, [])


    return (
        <>
        {
            loading ? 
            <div className="flex flex-col h-screen justify-center items-center h-full">
                <Spinner className="h-12 w-12" />
            </div>
            :
            <section className="py-32">
                <div className="container mx-auto">
                    <div className="items-center justify-center flex">
                        <div className="w-full px-12 mb-12 px-4">
                            <CardTable 
                                title={t(`${translationPrefix}.courses`)}
                                icon={faGraduationCap}
                                columns={columns} 
                                rows={cursos}
                                rowCount={rowCount}
                            />
                        </div>
                    </div>
                </div>
            </section>
        }
        </>
    )
}

export default Courses;